import ProfileView from '../components/ProfileView';

const Profile = () => (
  <>
    <ProfileView />
  </>
);

export default Profile;
